<template>
  <section class="buttons">
    <!-- Start -->
    <button
      class="start"
      v-bind:class="{
        grow: !hideStart,
      }"
      v-show="!hideStart && !isAppRunning"
      v-on:click="$emit('freshStartPressed')"
    >
      START
    </button>
    <!-- Pause, Resume, Delete, Start, Done -->
    <button
      v-bind:class="{
        'delete-done': isTimerResumed || showOnlyDone,
        pause: isTimerRunning,
        resume: isTimerPaused,
        start: isTimerReset,
      }"
      v-show="isAppRunning && !hideAll"
      v-on:click="timerPauseResumeStartDeleteDone"
    >
      {{ pauseResumeDeleteStartDoneButtonText }}
    </button>
    <!-- Reset, Delete(After reset) -->
    <button
      v-bind:class="{
        reset: isTimerRunning,
        'delete-done': isTimerPaused || isTimerReset,
      }"
      v-show="isAppRunning && !hideAll && !showOnlyDone"
      v-on:click="doResetOrDelete"
    >
      {{ resetDeleteButtonText }}
    </button>
  </section>
</template>

<script>
export default {
  name: "RbGoogButtons",
  props: {
    isAppRunning: Boolean,
    isTimerStarted: Boolean,
    isTimerRunning: Boolean,
    isTimerActive: Boolean,
    isTimerPaused: Boolean,
    isTimerReset: Boolean,
    isTimerResumed: Boolean,
    hideStart: Boolean,
    hideAll: Boolean,
    showOnlyDone: Boolean,
  },
  computed: {
    resetDeleteButtonText() {
      let buttonText = "";
      if (this.isTimerRunning) {
        buttonText = "RESET";
      } else if (this.isTimerPaused) {
        buttonText = "DELETE";
      } else if (this.isTimerReset) {
        buttonText = "DELETE";
      }
      return buttonText;
    },
    pauseResumeDeleteStartDoneButtonText() {
      let buttonText = "";
      if (this.isTimerRunning) {
        buttonText = "PAUSE";
      } else if (this.isTimerPaused) {
        buttonText = "RESUME";
      } else if (this.isTimerResumed) {
        buttonText = "DELETE";
      } else if (this.isTimerReset) {
        buttonText = "START";
      } else if (this.showOnlyDone) {
        buttonText = "DONE";
      }
      return buttonText;
    },
  },
  methods: {
    doResetOrDelete() {
      if (navigator && typeof navigator.vibrate === "function") {
        navigator.vibrate([10]);
      }
      if (this.isTimerRunning) {
        return this.$emit("resetPressed");
      } else {
        return this.$emit("doneOrDeletePressed");
      }
    },
    timerPauseResumeStartDeleteDone() {
      if (navigator && typeof navigator.vibrate === "function") {
        navigator.vibrate([10]);
      }
      if (this.isTimerRunning) {
        return this.$emit("pausePressed");
      } else if (this.isTimerPaused) {
        return this.$emit("resumePressed");
      } else if (this.isTimerReset) {
        return this.$emit("startPressed");
      }
      return this.$emit("doneOrDeletePressed");
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin animate($animation, $duration, $method, $times) {
  animation: $animation $duration $method $times;
}

@mixin keyframes($name) {
  @keyframes #{$name} {
    @content;
  }
}

.buttons {
  display: flex;
  justify-content: space-evenly;

  button {
    color: var(--blue-6);
    width: var(--size-fluid-7);
    height: var(--size-fluid-5);
    text-align: center;
    background-color: var(--teal-0);
    text-shadow: 0 1px 0 var(--blue-2);
    font-family: var(--font-mono);
    font-size: var(--font-size-fluid-1);
    font-weight: var(--font-weight-7);
    padding: var(--size-fluid-1);
    border-radius: var(--radius-2);
    aspect-ratio: var(--ratio-golden);
    box-shadow: var(--shadow-4);
    transition: all 0.1s linear;

    &:hover {
      cursor: pointer;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
    }

    &.start {
      color: var(--gray-9);
      background-color: var(--green-5);

      &.grow {
        @include keyframes(grow) {
          from {
            transform: scale(0);
          }
          to {
            transform: scale(1);
          }
        }

        @include animate(grow, 0.25s, linear, 1);
      }
    }

    &.delete-done {
      color: var(--gray-0);
      background-color: var(--red-6);
    }

    &.pause {
      color: var(--gray-0);
      background-color: var(--blue-6);
    }

    &.resume {
      color: var(--gray-9);
      background-color: var(--teal-5);
    }

    &.reset {
      color: var(--gray-9);
      background-color: var(--orange-5);
    }
  }
}
</style>
